import Skill from "./Skill/Skill";
import Address from "./Address/Address";
import Header from "./Header/Header";
import RouteWithTitle from '../../../Layout/RouteWithTitle';

function About() {
  return (
    <RouteWithTitle>
      <div className="w-full pt-14 text-custom_white" id="about">
        <div className="Container">
          <div className="sm:flex justify-center xl:flex flex-wrap" dir="rtl">
            <Header />
            <Skill />
            <Address />
          </div>
        </div>
      </div>
    </RouteWithTitle>
  );
}

export default About;
